import styles from "./boxSettings.module.css";

import { useEffect } from "react";
import ImgBuilder from "../../assets/ImgBuilder";
import { useTranslation } from "react-i18next";
import { useLanguage } from '../../functions/setGetLanguage';
import { supportedLanguages } from "../../i18n";
import { useSettings } from '../../functions/updateSettings';
// import { useNavigate } from "react-router-dom";
// import { useUserData } from "../../functions/updateUserData";

const BoxSettings = ({call, subcall, languageBox, confirm, handleCompletion, hdelay, settingsOptions}) => {
  // const { t } = useTranslation();

  const { setLanguage } = useLanguage();
  const { i18n } = useTranslation();

  const { settings, setSettings } = useSettings();

  useEffect(() => {
    const currentLang = i18n.language || "en";
    localStorage.setItem("i18nextLng", currentLang);
    setLanguage(`_${currentLang}`);
  }, [i18n.language, setLanguage]);

  const handleLanguage = (lang) => {
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  };

  const handleSettingsChange = (setting, value) => {
    setSettings(p => ({
      ...p,
      [setting]: value,  // use brackets to use variable as key
    }));
  };
  
  return (
    <div className={`${styles.boxModeSelector}`} style={{ "--hdelay": hdelay }}>
      <p className={styles.callToActionBox}>
        {call}
      </p>
      {subcall &&
        <p className={styles.subCallToActionBox}>
          {subcall}
        </p>
      }
      <div className={styles.settingsMainCon}>
        {languageBox &&
          <div className={styles.settingsItem}>

            <div className={styles.settingsItemContainer}>
              {Object.entries(supportedLanguages).map(([code, label]) => (
                <div 
                  key={label}
                  onClick={() => handleLanguage(code)} 
                  className={`${styles.settingsItemContainerChoice} ${code === i18n.language ? styles.activeMode :  " "}`}
                >
                  <div className={`${styles.circleSelected}`}></div>
                  {label}
                </div>
              ))}
            </div>

          </div>
        }
        {settingsOptions && settingsOptions.map((item, idx) => 
          <div key={idx} className={styles.settingsItem}>
            <div className={styles.settingsItemName}>
              {item.name} 
              <img alt="icon" className={styles.settingItemIcon} src={ImgBuilder[item.icon]}/>
            </div>

            <div className={styles.settingsItemContainer}>           
              {item.choices.map((choice, idx_choice) => 
                <div 
                  onClick={() => handleSettingsChange(item.id,choice.value)} 
                  key={idx_choice} 
                  className={`${styles.settingsItemContainerChoice} ${settings[item.id] === choice.value ? styles.activeMode : ""}`}
                >
                  <div className={`${styles.circleSelected}`}></div>
                  {choice.value_name}
                </div>
              )}
            </div>

          </div>
        )}

        {handleCompletion &&
          <button onClick={() => handleCompletion()} className={styles.buttonExplanationBox}>
            {confirm}
          </button>
        } 

      </div>

    </div>
  );
};
export default BoxSettings;

